import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectMap } from "../../features/counter/counterSlice";
import { parseMapToDOM } from "../../utils";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import { useEffect } from "react";
import { closeModal } from "../../features/findInPage/FindInPageSlice";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import FavouriteButton from "../FavouriteButton/FavouriteButton";
import useToast from "../../hooks/useToast";

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

const TopBar = ({ topicTitle, topicUrl }) => {
  const { isAppMode } = useAppModernisation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const findInPage = useFindInPage();
  const tableOfContents = useTableOfContents();
  const currentMap = useSelector(selectMap);
  const iconRight = classNames(
    "tg-icons-LeftArrow",
    "iconSize",
    style.rightArrow
  );
  const iconToc = classNames("tg-icons-FormattedListBullet", "iconSize");
  const iconFindInPage = classNames("tg-icons-FindInPage", "iconSize");
  const pageTocStyle = classNames("size-14", style.button, style.push);
  const standardButtonStyle = classNames("size-14", style.button);
  const toast = useToast();

  const triggerToast = (added) => {
    toast.triggerToast({
      type: "info",
      primaryMessage: added ? "Added to favourites" : "Removed from favourites",
      rightText: "<a href=\"/favourites\">View</a>",
      autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
    });
  }

  const goBack = () => {
    if (isAppMode) {
      // Parse the current map to DOM
      const xmlParsed = parseMapToDOM(currentMap);
      const activeElm = xmlParsed.querySelectorAll(
        "[class*='active']:not(ditatitle)",
      );

      const elmFilter = [...activeElm].filter(
        (el) => el.getAttribute("level") < 2,
      );

      if (elmFilter.length > 0) {
        const active = elmFilter[elmFilter.length - 1];
        let prePath = active.getAttribute("href").replace(".dita", "");
        if (
          active.getAttribute("level") === "0" &&
          active.tagName === "chapter"
        ) {
          prePath = active.getAttribute("href").split("/")[0];
        }
        if (prePath.includes("/c_") || prePath.includes("/tandf")) {
          console.log(prePath, "prePath!!!"); 
          const pathArray = prePath.split("/");
          pathArray.pop();
          prePath = pathArray.join("/");
        }
        const href = "/app/nav/" + prePath;
        window.location.href = href;
      } else {
        navigate(-1);
      }
    } else {
      navigate(-1);
    }
  };

  const handleOpenTocModal = (e) => {
    e.stopPropagation();
    findInPage.closeModal();
    tableOfContents.openModal();
  };

  // Close modal when page loaded
  useEffect(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return (
    <div className={style.topBar}>
      <button
        type="button"
        className={classNames("size-14", style.button, style.buttonRight)}
        onClick={goBack}
        aria-label="Go back"
      >
        <i className={iconRight}></i>
      </button>
      <button
        type="button"
        className={pageTocStyle}
        aria-label="Page Table of Contents Panel"
        onClick={handleOpenTocModal}
      >
        <i className={iconToc}></i>
      </button>
      <button
        type="button"
        className={standardButtonStyle}
        aria-label="Find in page"
        onClick={findInPage.openModal}
      >
        <i className={iconFindInPage}></i>
      </button>
      <FavouriteButton
        sectionTitle={topicTitle}
        sectionUrl={topicUrl}
        type='topic'
        triggerToast={triggerToast}
        styling={standardButtonStyle}
      />
    </div>
  );
};
export default TopBar;
